/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} L6_Intro_P1_BeforeInputs */

const es_l6_intro_p1_before = /** @type {(inputs: L6_Intro_P1_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si tu embarcación ya está registrada para alquiler comercial, Zarpar compite donde más importa: el precio. La misma comisión plana del `)
};

const gl_l6_intro_p1_before = /** @type {(inputs: L6_Intro_P1_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se a túa embarcación xa está rexistrada para alugueiro comercial, Zarpar compite onde máis importa: o prezo. A mesma comisión plana do `)
};

const en_l6_intro_p1_before = /** @type {(inputs: L6_Intro_P1_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If your vessel is already registered for commercial rental, Zarpar competes where it matters: price. The same flat commission of `)
};

/**
* | output |
* | --- |
* | "If your vessel is already registered for commercial rental, Zarpar competes where it matters: price. The same flat commission of" |
*
* @param {L6_Intro_P1_BeforeInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const l6_intro_p1_before = /** @type {((inputs?: L6_Intro_P1_BeforeInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<L6_Intro_P1_BeforeInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_l6_intro_p1_before(inputs)
	if (locale === "en") return en_l6_intro_p1_before(inputs)
	return es_l6_intro_p1_before(inputs)
});